import React from 'react';
import PreviewTable from './GHLPreviewTable';

function badge(status, error, sm) {
  const p = sm !== false ? '2px 8px' : '2px 6px';
  const f = sm !== false ? '11px' : '10px';
  if (status === 'ready')    return <span style={{ background:'#dcfce7',color:'#166534',borderRadius:'4px',padding:p,fontSize:f }}>✅ Ready</span>;
  if (status === 'no_tag')   return <span style={{ background:'#f3f4f6',color:'#6b7280',borderRadius:'4px',padding:p,fontSize:f }}>— No Tag</span>;
  if (status === 'no_count') return <span style={{ background:'#fef3c7',color:'#92400e',borderRadius:'4px',padding:p,fontSize:f }}>⚠️ No Count</span>;
  if (status === 'failed')   return <span title={error} style={{ background:'#fee2e2',color:'#991b1b',borderRadius:'4px',padding:p,fontSize:f }}>❌ Failed</span>;
  return null;
}

function GHLPreviewModal({ loading, data, saveLoading, onClose, onConfirm }) {
  return (
    <div style={{ position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px' }}>
      <div style={{ background:'#fff',borderRadius:'12px',width:'100%',maxWidth:'860px',maxHeight:'88vh',display:'flex',flexDirection:'column',boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ padding:'20px 24px 14px',borderBottom:'1px solid #e5e7eb',display:'flex',justifyContent:'space-between',alignItems:'flex-start' }}>
          <div>
            <h2 style={{ margin:0,fontSize:'18px',fontWeight:'700',color:'#111827' }}>🔄 GHL Count Preview — Review Before Saving</h2>
            <p style={{ margin:'5px 0 0',fontSize:'13px',color:'#6b7280' }}>Counts fetched <strong>live from GHL right now</strong>. Nothing saved yet. Verify below, then click "Confirm &amp; Save".</p>
          </div>
          <button onClick={onClose} style={{ background:'none',border:'none',fontSize:'22px',cursor:'pointer',color:'#6b7280',lineHeight:1,padding:'4px',marginLeft:'12px' }}>×</button>
        </div>
        <div style={{ padding:'16px 24px',overflowY:'auto',flex:1 }}>
          {loading && <div style={{ textAlign:'center',padding:'48px 0',color:'#6b7280' }}>⏳ Fetching from GHL for all agents, groups &amp; members…</div>}
          {!loading && data?.error && <div style={{ background:'#fef2f2',border:'1px solid #fca5a5',borderRadius:'8px',padding:'16px',color:'#dc2626' }}>❌ {data.error}</div>}
          {!loading && data?.preview && <PreviewTable data={data} />}
        </div>
        {!loading && data?.preview && (
          <div style={{ padding:'14px 24px',borderTop:'1px solid #e5e7eb',display:'flex',gap:'12px',justifyContent:'flex-end',background:'#f9fafb',borderRadius:'0 0 12px 12px' }}>
            <button onClick={onClose} disabled={saveLoading} style={{ padding:'10px 20px',background:'#fff',border:'1px solid #d1d5db',borderRadius:'6px',cursor:'pointer',fontWeight:'600',fontSize:'14px',color:'#374151' }}>Cancel</button>
            <button onClick={onConfirm} disabled={saveLoading||data.summary.ready===0} style={{ padding:'10px 24px',background:(saveLoading||data.summary.ready===0)?'#9ca3af':'#10b981',color:'#fff',border:'none',borderRadius:'6px',cursor:(saveLoading||data.summary.ready===0)?'not-allowed':'pointer',fontWeight:'700',fontSize:'14px' }}>
              {saveLoading?'⏳ Saving to DB…':`✅ Confirm & Save ${data.summary.ready} Count${data.summary.ready!==1?'s':''} to DB`}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default GHLPreviewModal;
